import { render, staticRenderFns } from "./StoriesArticleIllustratedMainImg.vue?vue&type=template&id=74114f7e&scoped=true&"
import script from "./StoriesArticleIllustratedMainImg.vue?vue&type=script&lang=js&"
export * from "./StoriesArticleIllustratedMainImg.vue?vue&type=script&lang=js&"
import style0 from "./StoriesArticleIllustratedMainImg.vue?vue&type=style&index=0&id=74114f7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74114f7e",
  null
  
)

export default component.exports